var version = {
    "name":      "dativery",
    "buildDateCode": "20260604-124408",
    "buildDate": "Thu Jun 04 2026 12:44:08 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260604-124408",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;